import Temporal from "@/shared/ts/temporal";
import store from "./store";
import dateTimeProvider from "./systemDateTimeProvider";

export default class TemporalDetail {
  public static getDefaultBenefitPaymentDate() {
    return this.getFutureDateBasedOnRetirementDate();
  }

  public static getOtherCashDefaultReceiptDate() {
    const retirementDate = new Date(store.state.retiree.retirementDate);

    if (store.state.retiree.alreadyDrawingPension) {
      return Temporal.getFirstOfNextMonth();
    } else {
      return retirementDate;
    }
  }

  public static getOtherIncomeDefaultPaidFromDate() {
    return this.getFutureDateBasedOnRetirementDate();
  }

  public static getOtherIncomeDefaultPaidToDate(): Date {
    const paidFromDate = this.getFutureDateBasedOnRetirementDate();
    paidFromDate.setFullYear(paidFromDate.getFullYear() + 5);
    return paidFromDate;
  }

  public static firstOfCurrentMonth(): Date {
    const now = dateTimeProvider.now()
    return new Date(now.getFullYear(), now.getMonth(), 1);
  }

  public static getFirstMonthOnOrAfterReference(referenceDate: Date, month: number): Date {
    if (month < 0 || month > 11) {
      throw new RangeError("month must be 0..11");
    }
    
    const referenceYear = referenceDate.getFullYear();
    const newMonthDate = new Date(referenceYear, month, 1);

    return newMonthDate >= referenceDate ? newMonthDate : new Date(referenceYear + 1, month, 1);
  }

  public static getFirstMonthOnOrBeforeReference(referenceDate: Date, month: number): Date {
    if (month < 0 || month > 11) {
      throw new RangeError("month must be 0..11");
    }
    
    const referenceYear = referenceDate.getFullYear();
    const newMonthDate = new Date(referenceYear, month, 1);

    return newMonthDate <= referenceDate ? newMonthDate : new Date(referenceYear - 1, month, 1);
  }

  public static isSameDate(a: Date, b: Date, utc = false): boolean {
    if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return false;

    return utc
      ? (a.getUTCFullYear() === b.getUTCFullYear() &&
        a.getUTCMonth() === b.getUTCMonth() &&
        a.getUTCDate() === b.getUTCDate())
      : (a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate());
  }

  public static monthsBetween(a: Date, b: Date): number {
    const sign = a <= b ? 1 : -1;
    const start = sign === 1 ? a : b;
    const end   = sign === 1 ? b : a;

    let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

    if (end.getDate() < start.getDate()) {
      months -= 1;
    }

    return sign * months;
  }
  
  private static getFutureDateBasedOnRetirementDate(): Date {
    const retirementDate = new Date(store.state.retiree.retirementDate);
    const currentDate = dateTimeProvider.now();

    if (retirementDate > currentDate) {
      return retirementDate;
    }

    return Temporal.getFirstOfNextMonth();
  }
}
